import { PropMappingType } from "./type";
export function normalizePropToPropertySetterMapping(tagName, propName, propMapping) {
    return Object.assign(Object.assign({}, propMapping), { tagName,
        propName });
}
export function asPropertySetter(propName) {
    return {
        mappingType: PropMappingType.PropertySetter,
        setter: {
            propName,
        },
    };
}
